<template>

	<div class="panel panel-clinic prospect">

		<div class="panel-heading collapsed" href="#form_prospect" data-toggle="collapse">

			<div class="arrow-down"></div>

			<h2 class="panel-title">Intyg & referenser</h2>

		</div>

		<div id="form_prospect" class="panel-collapse collapse">

			<div class="panel-body">

				<h3>Intyg, referenser och provmassage</h3>

				<div class="clinic-outer-form-group">

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showForced="true"
						:showDate="true"
						:showComment="true"
						type="file_education"
						layout="fileUploadMulti"
						title="Utbildningsbevis inkommet"
						comment="Välj ett eller flera utbildningsbevis.">
					</row-meta>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showForced="true"
						:showDate="true"
						:showComment="true"
						type="file_cert"
						layout="fileUpload"
						title="Cert bevis inkommet">
					</row-meta>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showForced="true"
						:showDate="true"
						:showComment="true"
						type="file_ftax"
						layout="fileUpload"
						title="Registerutdrag f-skatt inkommet">
					</row-meta>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showForced="true"
						:showDate="true"
						:showComment="true"
						type="file_insurance"
						layout="fileUpload"
						title="Patient- och ansvarsförsäkring inkommet">
					</row-meta>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showForced="false"
						:showDate="true"
						:showComment="true"
						type="checkbox_reference_taken"
						layout="checkBox"
						title="Referenstagning utförd (ej obl)">
					</row-meta>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:extra-data="{'Ja': 1, 'Nej': 0}"
						:showForced="false"
						:showDate="true"
						:showComment="true"
						type="trial_do"
						layout="selectMenu"
						title="Ska provmassage utföras?">
					</row-meta>

					<div v-show="validateRule('do_trial_massage')">

						<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:showForced="true"
							:showDate="true"
							:showComment="true"
							type="trial_booked"
							layout="checkBox"
							title="Provmassage inbokad">
						</row-meta>

						<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:showForced="true"
							:showDate="true"
							:showComment="true"
							type="trial_done"
							layout="fileUpload"
							title="Provmassager utförd">
						</row-meta>

					</div>

				</div>

				<h3>Ifyllt under "Namn & kontaktuppgifter"</h3>

				<div class="clinic-outer-form-group">

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showForced="true"
						:showDate="false"
						:showComment="true"
						:rule="validateRule('rule_contact')"
						type="rule_contact"
						layout="rule"
						title="Kontaktuppgifter inkomna">
					</row-meta>

				</div>

				<h3>Ifyllda priser under "Kontouppgifter & ersättningar"</h3>

				<div class="clinic-outer-form-group">

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:extra-data="payments.periods"
						:showForced="false"
						:showDate="false"
						:showComment="true"
						:rule="validateRule('rule_has_prices_internal')"
						type="rule_has_prices_internal"
						layout="rule"
						title="Har priser för mottagningsmassage">
					</row-meta>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:extra-data="payments.periods"
						:showForced="false"
						:showDate="false"
						:showComment="true"
						:rule="validateRule('rule_has_prices_external')"
						type="rule_has_prices_external"
						layout="rule"
						title="Har priser för företagsmassage">
					</row-meta>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:extra-data="payments.periods"
						:showForced="false"
						:showDate="false"
						:showComment="true"
						:rule="validateRule('rule_has_prices_pt')"
						type="rule_has_prices_pt"
						layout="rule"
						title="Har priser för PT">
					</row-meta>

				</div>

			</div>

		</div>

	</div>

</template>

<script>

import mixin from './mixin'

export default {

    	mixins: [mixin],

	    data () {
      		return {

      		}
	    }

}

</script>
